var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-16"},[_c('v-card',{style:({ margin: '0 auto' }),attrs:{"max-width":"600px"}},[_c('v-card-title',[_c('div',{staticClass:"text-button mb-4"},[_vm._v("Contact Me")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }